import React, { useRef, useState } from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';
import { Button, FormControl, FormHelperText } from '@material-ui/core';
import { IconButton, Input, Paper, Popover } from '@material-ui/core';
import { FormGroup, FormControlLabel, Checkbox } from '@material-ui/core';
import { FaRegSmile } from 'react-icons/fa';

import { EmojiPicker, Media, Tooltip } from 'components';

import {
  changeTemplateName,
  changeTemplateIcon,
  setTemplateIconUrl,
  changePointsPerPlay,
  changePointsPerWin,
} from '../actions';

import styles from './ControlPanel.module.scss';

const ControlPanel = props => {
  const [dialog, setDialog] = useState({});
  const nameSelection = useRef();

  const addEmoji = emoji => {
    const { templateName: name, changeTemplateName } = props;
    const selection = nameSelection.current;

    if (Array.isArray(selection) && selection.length >= 2) {
      const [start, end] = selection;
      const pos = start + emoji.length;

      changeTemplateName(`${name.substring(0, start)}${emoji}${name.substring(end)}`);
      nameSelection.current = [pos, pos];
    } else {
      changeTemplateName(`${name}${emoji}`);
    }
  };

  // FIXME: deprecated download page.
  // Need to implement the new 'Fixed Screens' approach in brackets editor
  const standalone = () => {
    if (props.type === 'brackets') {
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.hasDownloadPage}
                  onChange={props.updateStand}
                  value="checkedA"
                />
              }
              label="Standalone"
            />
          </FormGroup>

          {props.hasDownloadPage ? (
            <Button variant="contained" color="primary" onClick={props.fillDialogForm}>
              Standalone options
            </Button>
          ) : null}
        </div>
      );
    }
  };

  return (
    <Paper className={styles.controlPanel}>
      <div>
        <div className={styles.trigger}>
          <div>
            <Media
              scale={100}
              mediaFile={props.templateIcon}
              mediaUrl={props.templateIconUrl}
              onChange={({ mediaFile, mediaUrl }) => {
                props.changeTemplateIcon(mediaFile || '');
                props.setTemplateIconUrl(mediaUrl);
              }}
            />
          </div>
          <div>Trigger Icon</div>
        </div>

        <FormControl className={styles.field} style={{ width: 250 }}>
          <Input
            value={props.templateName}
            onChange={e => {
              nameSelection.current = null;
              props.changeTemplateName(e.target.value);
            }}
            onSelect={e =>
              (nameSelection.current = [e.target.selectionStart, e.target.selectionEnd])
            }
            type="text"
          />

          <FormHelperText className={styles.emojiLabel}>
            <span>Display Title</span>

            <IconButton onClick={e => setDialog({ emoji: e.currentTarget })}>
              <Tooltip title="Add Emoji" placement="top">
                <FaRegSmile />
              </Tooltip>
            </IconButton>
          </FormHelperText>
        </FormControl>

        <FormControl className={styles.field}>
          <Input
            type="number"
            value={props.pointsPerPlay}
            onChange={e => {
              props.changePointsPerPlay(Number(e.target.value));
            }}
            inputProps={{ min: 0 }}
          />
          <FormHelperText>Reward Points For Play</FormHelperText>
        </FormControl>

        <FormControl className={styles.field}>
          <Input
            type="number"
            value={props.pointsPerWin}
            onChange={e => {
              props.changePointsPerWin(Number(e.target.value));
            }}
            inputProps={{ min: 0 }}
          />
          <FormHelperText>Reward Points For Winning</FormHelperText>
        </FormControl>

        <div className={styles.preview}>
          <Button variant="contained" color="primary" onClick={props.showPreview}>
            preview
          </Button>
        </div>

        {standalone()}
      </div>

      <div>{props.children}</div>

      <Popover
        open={!!dialog.emoji}
        anchorEl={dialog.emoji}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        onClose={() => {
          setDialog({});
          nameSelection.current = null;
        }}
      >
        <EmojiPicker onSelect={addEmoji} style={{ maxWidth: 500 }} />
      </Popover>
    </Paper>
  );
};

const mapStateToProps = state =>
  _.pick(state, [
    'templateName',
    'templateIcon',
    'templateIconUrl',
    'pointsPerPlay',
    'pointsPerWin',
  ]);

const mapDispatchToProps = {
  changeTemplateName,
  changeTemplateIcon,
  setTemplateIconUrl,
  changePointsPerPlay,
  changePointsPerWin,
};

export default connect(mapStateToProps, mapDispatchToProps)(ControlPanel);
